<form [formGroup]="confirmUserForm" (ngSubmit)="confirmar()">
  <div>
    <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
    <div class="register-photo" style="background-color:rgb(255,255,255);">
      <div class="form-container">
        <div class="image-holder">
          <img src="assets/img/DNM/logo_20.png" style="padding-top: 4.5%;">
        </div>
        <div class="form" style="align-self: center!important;">
          <h2 style="text-align: center;"><strong>Confirmación de Usuario</strong></h2>
          <div class="p-customMessage" *ngIf="temp_mail_register !== ''"> 
            Se ha enviado un código de confirmación a su dirección de correo electrónico. 
          </div>
          <div *ngIf="!confirmacionForm">
            <div class="input-group">
              <label>Correo electrónico:</label>
              <div style="font-size: 16px; font-weight: bold; margin-top: 10px;">
                {{ correo }}
              </div>
            </div>
            <div class="input-group">
              <label>Código:</label>
              <div style="font-size: 16px; font-weight: bold; margin-top: 10px;">
                {{ codigo }}
              </div>
            </div>
            <div class="input-group" *ngIf="!error && !confirmacionForm && msgConfirm">
              <div style="font-size: 24px; text-align: center;">
                <p-progressSpinner mode="indeterminate" [style]="{width: '60px', height: '60px'}" strokeWidth="5"
                                   stroke="#fff"></p-progressSpinner>
                <br/>
                Confirmando usuario...
              </div>
            </div>
            <div class="input-group" *ngIf="error">
              <button type="button" (click)="confirmacionManual()" label="Confirmar" pButton></button>
            </div>
          </div>

          <div *ngIf="confirmacionForm">
            <div class="input-group">
              <input type="text" required formControlName="correo" id="correo" 
                     autocomplete="off" autofocus placeholder="Correo electrónico" pInputText
                     class="ui-inputtext ui-widget">
              <span *ngIf="confirmUserForm.get('correo').hasError('pattern')">
                  <p-message severity="error" text="Verifique el correo electrónico ingresado"></p-message>
              </span>
            </div>
            <div class="input-group">
              <input type="text" required formControlName="codigo" id="codigo"
                     autocomplete="off" placeholder="Código de confirmación" maxlength="5" pInputText
                     class="ui-inputtext ui-widget">
              <span *ngIf="confirmUserForm.get('codigo').hasError('minlength')">
                  <p-message severity="error" text="El código debe tener 5 caracteres"></p-message>
              </span>
            </div>
            <div class="input-group" style="margin-bottom: 1rem;">
              <button type="submit" style="background-color: #313945; border-color: #0D1175;" label="Confirmar" pButton [disabled]="!confirmUserForm.valid"></button>
            </div>

            <div class="input-wrapper" style="margin-bottom: 1.5rem; text-align: center;">
              <a routerLink="/auth/solicitar-confirmacion" style="color: #0719E3;">Deseo recuperar mi código de confirmación</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner [visible]="visibleSpinner"></app-spinner>
  </div>
</form>
